import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-statics-privacity",
  templateUrl: "./statics-privacity.component.html",
  styleUrls: ["./statics-privacity.component.scss"],
})
export class StaticsPrivacityComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {}

  close() {
    this.router.navigate(["/"]);
  }
}
